import Simplebar from 'simplebar';

import { isMobile } from '../modules/DeviceOptions';

const initSimplebar = () => {
  // don't do anything if native
  if (isMobile) {
    return;
  }

  $('.simplebarWeb').each((index, elm) => {
    const sb = new Simplebar(elm);
    $(elm).data('sb', sb);
  });
};

initSimplebar();
